'use strict';

// Interactions
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

// Sub-modules
import emailModule from './email';
import dispositionCodeModule from './dispositionCode';
import recordingsModule from './recordings';

const state = {
  interactions: {
    active: [],
    pending: [],
    history: []
  },
  historySince: Date.now()
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,

  modules: {
    emails: emailModule,
    dispositionCodes: dispositionCodeModule,
    recordings: recordingsModule
  }
};
